import { render, staticRenderFns } from "./layoutHome.vue?vue&type=template&id=24287ffe&scoped=true&"
import script from "./layoutHome.vue?vue&type=script&lang=js&"
export * from "./layoutHome.vue?vue&type=script&lang=js&"
import style0 from "./layoutHome.vue?vue&type=style&index=0&id=24287ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24287ffe",
  null
  
)

export default component.exports